import { render } from "./index.vue?vue&type=template&id=9e40eefc&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=9e40eefc&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Frontend_yitoutiao-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e40eefc"]])

export default __exports__